import React, { useState, useEffect } from 'react';
import Sidebar from './containers/sidebar';
import BodyLayout from './containers/bodyLayout';
import Login from './containers/login';
import ApiService from './services/ApiService';
import './index.css';

import { useNavigate } from 'react-router';
import { NotificationProvider } from './common/notoficationsContext';

const App = () => {
  const navigate = useNavigate();
  // const [role, setRole] = useState(localStorage.getItem('role') || 'CEO'); // You can switch between 'ceo' and 'subdealer'
  const [role, setRole] = useState('');
  const [permission, setPermission] = useState([]);

  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem('role') || false
  );

  const [loading, setLoading] = useState(true);

  const homeRole = localStorage.getItem('role');
  const webUI = localStorage.getItem('webUI');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // State to handle sidebar visibility


  // useEffect(() => {
  //   const verifyStaff = async () => {
  //     try {
  //       const staffId = localStorage.getItem('userId');
  //       const companyCode = localStorage.getItem('companyCode');
  //       const unitCode = localStorage.getItem('unitCode');

  //       if (!staffId || !companyCode || !unitCode) {
  //         localStorage.clear();
  //         setIsLoggedIn(false);
  //         return;
  //       }

  //       const res = await ApiService.post('/login/verifyStaffSession', {
  //         staffId,
  //         companyCode,
  //         unitCode,
  //       });

  //       if (!res.status) {
  //         localStorage.clear();
  //         setIsLoggedIn(false);
  //         navigate('/');
  //         return;
  //       }

  //       const realUser = res.data;
  //       const realRole = realUser.designation;

  //       localStorage.setItem('role', realRole);
  //       localStorage.setItem('isLoggedIn', 'true');
  //       localStorage.setItem('userProfile', JSON.stringify(realUser));

  //       let verifiedPermissions = [];

  //       if (realUser.permissions?.length) {
  //         const lastPermission =
  //           realUser.permissions[realUser.permissions.length - 1];

  //         verifiedPermissions = lastPermission.permissions || [];

  //         localStorage.setItem(
  //           'userPermissions',
  //           JSON.stringify(verifiedPermissions)
  //         );
  //       } else {
  //         localStorage.setItem('userPermissions', JSON.stringify([]));
  //       }

  //       setPermission(verifiedPermissions);

  //       window.dispatchEvent(new Event('authUpdated'));

  //       setRole(realRole);
  //       setIsLoggedIn(true);

  //       navigate(getHomeRoute(realRole), { replace: true });
  //     } catch (error) {
  //       localStorage.clear();
  //       setIsLoggedIn(false);
  //       navigate('/');
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (localStorage.getItem('userId')) {
  //     verifyStaff();
  //   } else {
  //     setLoading(false);
  //   }
  // }, []);


  const verifyStaff = async () => {
    try {
      setLoading(true);

      const staffId = localStorage.getItem('userId');
      const companyCode = localStorage.getItem('companyCode');
      const unitCode = localStorage.getItem('unitCode');

      if (!staffId || !companyCode || !unitCode) {
        localStorage.clear();
        setIsLoggedIn(false);
        return;
      }

      const res = await ApiService.post('/login/verifyStaffSession', {
        staffId,
        companyCode,
        unitCode,
      });

      if (!res.status) {
        localStorage.clear();
        setIsLoggedIn(false);
        navigate('/');
        return;
      }

      const realUser = res.data;
      const realRole = realUser.designation;

      let verifiedPermissions = [];

      if (realUser.permissions?.length) {
        const activePermission =
          realUser.permissions.find((p) => p.staffStatus === 'ACTIVE') ||
          realUser.permissions[realUser.permissions.length - 1];

        verifiedPermissions = activePermission.permissions || [];

        localStorage.setItem(
          'userPermissions',
          JSON.stringify(verifiedPermissions)
        );
      } else {
        localStorage.setItem('userPermissions', JSON.stringify([]));
      }

      localStorage.setItem('role', realRole);
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('userProfile', JSON.stringify(realUser));

      setPermission(verifiedPermissions);
      setRole(realRole);
      setIsLoggedIn(true);

      // navigate(getHomeRoute(realRole), { replace: true });
      const currentPath = window.location.pathname;

      if (currentPath === '/' || currentPath === '/login') {
        navigate(getHomeRoute(realRole), { replace: true });
      }
    } catch (error) {
      localStorage.clear();
      setIsLoggedIn(false);
      navigate('/');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem('userId')) {
      verifyStaff();
    } else {
      setLoading(false);
    }
  }, []);

  const getHomeRoute = (role) => {
    switch (role) {
      case 'CEO':
        return '/home';
      case 'Tele Calling Associate':
        return '/customer-care-home';
      case 'Accountant':
        return '/home';
      case 'Technician':
        return '/technician-home';
      case 'Warehouse Manager':
        return '/warehouse-manager-home';
      case 'Sub Dealer':
        return '/sub-dealer-home';
      case 'Sales Man':
        return '/salesman-home';
      case 'Branch Manager':
        return '/branch-manager-home';
      case 'Backend Support Executive':
        return '/backend-support-home';
      case 'HR':
        return '/hr-home';
      case 'SEO Content Manager':
        return '/BlogPage';
      default:
        return '/custom-home';
    }
  };

  // const handleLoginFlag = () => {
  //   const realRole = localStorage.getItem('role');

  //   localStorage.setItem('isLoggedIn', 'true');
  //   setRole(realRole);
  //   setIsLoggedIn(true);

  //   navigate(getHomeRoute(realRole), { replace: true });
  // };

  const handleLoginFlag = () => {
    verifyStaff();
  };

  // const handleLoginFlag = () => {
  //   localStorage.setItem('isLoggedIn', 'true');
  //   setRole(localStorage.getItem('role'));
  //   switch (localStorage.getItem('role')) {
  //     case 'CEO':
  //       navigate('/home');
  //       break;
  //     case 'Tele Calling Associate':
  //       navigate('/customer-care-home');
  //       break;
  //     case 'Accountant':
  //       navigate('/home');
  //       break;
  //     case 'Technician':
  //       navigate('/technician-home');
  //       break;
  //     case 'Warehouse Manager':
  //       navigate('/warehouse-manager-home');
  //       break;
  //     case 'Sub Dealer':
  //       navigate('/sub-dealer-home');
  //       break;
  //     case 'Sales Man':
  //       navigate('/salesman-home');
  //       break;
  //     case 'Branch Manager':
  //       navigate('/branch-manager-home');
  //       break;
  //     case 'Backend Support Executive':
  //       navigate('/backend-support-home');
  //       break;
  //     case 'HR':
  //       navigate('/hr-home');
  //       break;
  //     case 'SEO Content Manager':
  //       navigate('/BlogPage');
  //       break;
  //     default:
  //       navigate('/custom-home');
  //       break;

  //   }
  //   setIsLoggedIn(true);
  // };

  const handleLogoutFlag = () => {
    setIsLoggedIn(false);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      {!isLoggedIn ? (
        <div>
          <Login handleLoginFlag={handleLoginFlag} />
        </div>
      ) : (
        <div className="flex">
          {/* Sidebar */}
          {homeRole === 'CEO' && webUI ? (
            ''
          ) : (
            <div
              className={`bg-gray-800 text-white transition-transform transform z-50 h-screen overflow-y-auto scrollbar-hide
${isSidebarOpen ? 'fixed top-0 left-0 w-64 translate-x-0' : 'fixed top-0 left-0 w-64 -translate-x-full'} 
md:sticky md:top-0 md:translate-x-0 md:w-64 md:flex-shrink-0`}
            >
              {/* Close button for mobile */}
              <button
                className="block md:hidden p-4 text-right text-white"
                onClick={toggleSidebar}
              >
                ✕
              </button>
              {/* <Sidebar role={role} handleLogoutFlag={handleLogoutFlag} /> */}
              <Sidebar
                role={role}
                permission={permission}
                handleLogoutFlag={handleLogoutFlag}
              />
            </div>
          )}

          {/* Main Content */}
          {/* <div className="flex-1 overflow-auto w-full md:w-3/4 bg-white"> */}
          <div className="flex-1 min-w-0 bg-white">
            {/* Mobile Menu Button */}
            <button
              className="fixed top-4 left-4 p-2 rounded bg-blue-500 text-white z-50 md:hidden"
              onClick={toggleSidebar}
            >
              ☰
            </button>
            {/* <NotificationProvider>
              <BodyLayout></BodyLayout>
            </NotificationProvider> */}
            {role?.toLowerCase() === 'seo content manager' ? (
              <BodyLayout role={role} seoOnly={true} />
            ) : (
              <NotificationProvider>
                <BodyLayout role={role} seoOnly={false} />
              </NotificationProvider>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
